<template>
  <luma-empty>
    <b-button @click="get()">GET</b-button>
  </luma-empty>
</template>

<script>
    import LumaEmpty from "@/layout/LumaEmpty";
    import {Billing} from "@/store/models/accounting/billing";

    export default {
        name: "accounting-billing-single",
        components: {LumaEmpty},
        methods:{
            get(){
                return Billing.fetch()
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/bill_accounting/accounting-billing-single.vue